export default __webpack_public_path__ + "static/media/3.0fb8f7f8.png";